/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Invalid_InputInputs */

const en_error_invalid_input = /** @type {(inputs: Error_Invalid_InputInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A value has an invalid format.`)
};

/**
* | output |
* | --- |
* | "A value has an invalid format." |
*
* @param {Error_Invalid_InputInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_invalid_input = /** @type {((inputs?: Error_Invalid_InputInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Invalid_InputInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_invalid_input(inputs)
});